import BaseException from './BaseException';

export default class NoSubscriptionException extends BaseException {
  readonly name = 'NoSubscriptionException';

  constructor() {
    super({
      errors: [
        {
          status: 402,
          description: 'core.error.subscription',
        },
      ],
    });
  }
}
